// export const PRIVILEGES = {
//   SHOW_HISTORY_PAGE: ["view_history_page"],
//   SHOW_USER_MANAGEMENT: ["view_user_management"],
//   EDIT_USER: ["edit_user"],
//   INVITE_USER: ["invite_user"],
//   ENABLE_REVOKE_ACCESS: ["enable_revoke_access"],
//   ENABLE_SFTP_ACCESS: ["enable_sftp_access"],
//   SHOW_CAMPAIGN_MANAGEMENT: ["view_campaign_management"],
//   SHOW_EMAIL_TEMPLATE_MANAGEMENT: ["view_email_template_management"],
//   CREATE_EMAIL_TEMPLATE: ["create_email_template"],
//   EDIT_EMAIL_TEMPLATE: ["edit_email_template"],
//   DELETE_EMAIL_TEMPLATE: ["delete_email_template"],
//   SHOW_EMAIL_CAMPAIGN_MANAGEMENT: ["view_email_campaign_management"],
//   CREATE_EMAIL_CAMPAIGN: ["create_email_campaign"],
//   EDIT_EMAIL_CAMPAIGN: ["edit_email_campaign"],
//   DELETE_EMAIL_CAMPAIGN: ["delete_email_campaign"],
//   SHOW_SMS_CAMPAIGN_MANAGEMENT: ["view_sms_campaign_management"],
//   CREATE_SMS_CAMPAIGN: ["create_sms_campaign"],
//   EDIT_SMS_CAMPAIGN: ["edit_sms_campaign"],
//   DELETE_SMS_CAMPAIGN: ["delete_sms_campaign"],
//   SHOW_CONSUMER_LIST_MANAGEMENT: ["view_consumer_list_management"],
//   EDIT_CONSUMER_LIST: ["edit_consumer_list"],
//   DELETE_CONSUMER_LIST: ["delete_consumer_list"],
// };

export const PRIVILEGES = {
  SHOW_HISTORY_PAGE: ["view_history_page"],
  SHOW_SUBSCRIPTION_PAGE: ["view_subscription"],

  SHOW_USER_MANAGEMENT: ["view_user_management"],
  EDIT_USER: ["edit_client_user"],
  INVITE_USER: ["add_client_user"],
  ENABLE_REVOKE_ACCESS: ["edit_revoke_access"],
  ENABLE_SFTP_ACCESS: ["add_ftp"],
  ENABLE_PENDING_INVITATION: ["list_applicant"],
  ENABLE_INVITATION_APPROVAL: ["edit_applicant"],
  ENABLE_RESEND_INVITATION: ["add_client_user"],

  SHOW_CAMPAIGN_MANAGEMENT: ["view_campaign_management"],

  SHOW_EMAIL_TEMPLATE_MANAGEMENT: ["view_email_template_management"],
  VIEW_EMAIL_TEMPLATE: ["view_template"],
  CREATE_EMAIL_TEMPLATE: ["add_template"],
  EDIT_EMAIL_TEMPLATE: ["edit_template"],
  DELETE_EMAIL_TEMPLATE: ["delete_template"],

  SHOW_EMAIL_CAMPAIGN_MANAGEMENT: ["view_email_campaign_management"],
  VIEW_EMAIL_CAMPAIGN: ["view_campaign"],
  CREATE_EMAIL_CAMPAIGN: ["add_campaign"],
  EDIT_EMAIL_CAMPAIGN: ["edit_campaign"],
  DELETE_EMAIL_CAMPAIGN: ["delete_campaign"],
  VIEW_EMAIL_CAMPAIGN_REPORT: ["view_campaignsummary"],

  SHOW_SMS_CAMPAIGN_MANAGEMENT: ["view_sms_campaign_management"],
  VIEW_SMS_CAMPAIGN: ["view_sms_campaign"],
  CREATE_SMS_CAMPAIGN: ["add_sms_campaign"],
  EDIT_SMS_CAMPAIGN: ["edit_sms_campaign"],
  DELETE_SMS_CAMPAIGN: ["delete_sms_campaign"],
  VIEW_SMS_CAMPAIGN_REPORT: ["view_campaignsummary"],

  SHOW_CONSUMER_LIST_MANAGEMENT: ["view_consumer_list_management"],
  EDIT_CONSUMER_LIST: ["edit_customer"],
  DELETE_CONSUMER_LIST: ["delete_customer"],

  DASHBOARD_PAGE_ACCESS: ["list_dashboard_data"],
  DASHBOARD_PDF_ACCESS: ["dashboard_export"],
  FHS_PDF_ACCESS: ["fhs_export"],
  EXPORT_DATA_ACCESS: ["export_data"],
  SHOW_EWI_STRATEGIES: ["list_ewi"],

  DRILLDOWN_ACCESS: ["list_drilldown_data"],

  VIEW_FILTERS: ["view_save_filter"],
  SAVE_FILTER: ["add_save_filter"],
  EDIT_FILTER: ["edit_save_filter"],
  DELETE_FILTER: ["delete_save_filter"],
  TEST: ["dsfdfs"],
};
